/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// Bootstrap
import bootstrap from "bootstrap/dist/js/bootstrap.js";

// Sliders
import Swiper from "swiper/bundle";

// GLighbox
import GLightbox from "glightbox";
import { initializeBasketModule } from "./modules/basket";
import { initializeToaster } from "./modules/toaster";
import { initSorter } from "./modules/sorter";
import { initializeTrackingModule } from "./modules/tracking";
import { initializeConsentModule } from "./modules/consent";
import {resizeTextToFit} from "./modules/utils";

document.addEventListener("DOMContentLoaded", () => {
    // inicializace bootstrap tooltipu
    const tooltipTriggerList = document.querySelectorAll(
        "[data-bs-toggle=\"tooltip\"]",
    );
    const _ = [...tooltipTriggerList].map(
        (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl),
    );

    // inicializace Swiper
    // swiper na HP nahore
    new Swiper(".homeSlider", {
        pagination: {
            el: ".swiper-pagination-slider",
            clickable: true,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: true
        },
    });

    // swiper na HP dole
    new Swiper(".recomendedProducts", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        pagination: {
            el: ".swiper-pagination-products",
            clickable: true,
        },

        slidesPerView: 1,
        spaceBetween: 15,

        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 25,
            },
            1440: {
                slidesPerView: 4,
                spaceBetween: 25,
            },
        },
    });

    // kosik pridavani produktu
    // Získání všech tlačítek "+" a "-" a všech inputů
    const plusButtons = document.querySelectorAll(".plus");
    const minusButtons = document.querySelectorAll(".minus");
    const quantityInputs = document.querySelectorAll(".quantity");

    // Funkce pro přidání nebo odečítání hodnoty v inputu
    plusButtons.forEach((button, index) => {
        button.addEventListener("click", () => {
            const input = quantityInputs[index];
            const currentValue = Number.parseInt(input.value);
            input.value = currentValue + 1; // Zvyšuje počet o 1
        });
    });

    minusButtons.forEach((button, index) => {
        button.addEventListener("click", () => {
            const input = quantityInputs[index];
            const currentValue = Number.parseInt(input.value);
            if (currentValue > 1) {
                input.value = currentValue - 1; // Snižuje počet o 1, pokud není jedna
            }
        });
    });

    // Lightbox Galerie
    GLightbox({
        touchNavigation: true,
        openEffect: "fade",
        closeEffect: "fade",
        zoomable: false,
    });

    // Filter actions
    for (const link of document.querySelectorAll(".js-filter-remove-link")) {
        const url = new URL(location.href);
        url.searchParams.delete(`${link.dataset.name}`);
        url.searchParams.delete(`${link.dataset.name}[]`);
        link.setAttribute("href", url.toString());
    }

    initializeBasketModule();
    initializeToaster(bootstrap);
    initializeTrackingModule();
    initializeConsentModule();
    initSorter();
});

//Moved outside dom document as this might get distorted cause of missing dependencies
window.addEventListener('load', () =>  document.querySelectorAll("[data-tool='resize-text-to-fit']").forEach(resizeTextToFit));
